import { IconsTypesProps } from '../../types';

export const SpinningPumpScadaIcon = ({
  width = 31,
  height = 54,
  fill = '#05B6B2',
}: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 31 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22909_12561)">
      <path
        d="M30.6772 48.6189C30.6772 51.3909 28.384 53.627 25.5833 53.627H5.28247C2.46292 53.627 0.188477 51.3724 0.188477 48.6189C0.188477 45.8654 2.46292 43.6108 5.28247 43.6108H5.90277V36.7917H5.26367C3.59074 36.7917 2.23735 35.4611 2.23735 33.8164V33.3729C2.23735 31.7281 3.59074 30.3976 5.26367 30.3976H5.90277V8.8314C5.90277 7.815 6.74864 6.9834 7.78247 6.9834H23.0645C24.0983 6.9834 24.9442 7.815 24.9442 8.8314V30.3976H25.5833C27.2562 30.3976 28.6096 31.7281 28.6096 33.3729V33.8164C28.6096 35.4611 27.2562 36.7917 25.5833 36.7917H24.9442V43.6108H25.5645C28.384 43.6108 30.6772 45.8469 30.6772 48.6189Z"
        fill="#F4F4F7"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M10.0381 10.8638V26.0544"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M12.7256 10.8638V26.0544"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4326 10.8638V26.0544"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M18.1396 10.8638V26.0544"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M20.8271 10.8638V26.0544"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M21.9365 6.96456V2.56631C21.9365 1.34663 20.9214 0.367188 19.6996 0.367188H11.0718C9.8312 0.385668 8.83496 1.36511 8.83496 2.56631V6.96456H10.7147V2.56631C10.7147 2.36303 10.8838 2.21519 11.0718 2.21519H19.6808C19.8124 2.21519 19.944 2.28911 20.0004 2.41847V6.98304H21.9365V6.96456Z"
        fill="#C9CDCF"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M15.376 46.4003C19.3521 46.4003 22.5753 43.2315 22.5753 39.3225C22.5753 35.4135 19.3521 32.2446 15.376 32.2446C11.4 32.2446 8.17676 35.4135 8.17676 39.3225C8.17676 43.2315 11.4 46.4003 15.376 46.4003Z"
        fill={fill}
      />
      <path
        d="M15.3952 35.2942V28.8262C15.3952 28.8262 13.0832 29.6023 13.008 32.4483C11.9178 32.8179 10.9216 33.4277 10.1133 34.2408"
        fill={fill}
      />
      <path
        d="M15.3952 35.2942V28.8262C15.3952 28.8262 13.0832 29.6023 13.008 32.4483C11.9178 32.8179 10.9216 33.4277 10.1133 34.2408"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4625 36.5138L7.81962 31.9492C7.81962 31.9492 6.74819 34.0929 8.72188 36.1627C8.23316 37.1421 7.9888 38.2324 7.9888 39.3228C7.9888 39.3597 7.9888 39.3782 7.9888 39.4152"
        fill={fill}
      />
      <path
        d="M12.4625 36.5138L7.81962 31.9492C7.81962 31.9492 6.74819 34.0929 8.72188 36.1627C8.23316 37.1421 7.9888 38.2324 7.9888 39.3228C7.9888 39.3597 7.9888 39.3782 7.9888 39.4152"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M11.2782 39.415H4.69922C4.69922 39.415 5.48869 41.7066 8.42103 41.7805C8.79697 42.8338 9.43607 43.7948 10.2631 44.571"
        fill={fill}
      />
      <path
        d="M11.2782 39.415H4.69922C4.69922 39.415 5.48869 41.7066 8.42103 41.7805C8.79697 42.8338 9.43607 43.7948 10.2631 44.571"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M12.5188 42.2979L7.87598 46.8624C7.87598 46.8624 10.1128 47.9343 12.2369 45.9015C13.2143 46.345 14.2858 46.5852 15.376 46.5852"
        fill={fill}
      />
      <path
        d="M12.5188 42.2979L7.87598 46.8624C7.87598 46.8624 10.1128 47.9343 12.2369 45.9015C13.2143 46.345 14.2858 46.5852 15.376 46.5852"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4697 43.4619V49.9299C15.4697 49.9299 17.8569 49.1353 17.8757 46.16C18.9096 45.7904 19.8494 45.199 20.6201 44.4414"
        fill={fill}
      />
      <path
        d="M15.4697 43.4619V49.9299C15.4697 49.9299 17.8569 49.1353 17.8757 46.16C18.9096 45.7904 19.8494 45.199 20.6201 44.4414"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M18.4023 42.2426L23.064 46.8256C23.064 46.8256 24.173 44.5896 22.049 42.4828C22.5377 41.5034 22.782 40.4131 22.782 39.3228"
        fill={fill}
      />
      <path
        d="M18.4023 42.2426L23.064 46.8256C23.064 46.8256 24.173 44.5896 22.049 42.4828C22.5377 41.5034 22.782 40.4131 22.782 39.3228"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M18.3457 36.4585L23.0073 31.8939C23.0073 31.8939 20.7893 30.822 18.684 32.8179C17.669 32.3189 16.5411 32.0602 15.3945 32.0602"
        fill={fill}
      />
      <path
        d="M18.3457 36.4585L23.0073 31.8939C23.0073 31.8939 20.7893 30.822 18.684 32.8179C17.669 32.3189 16.5411 32.0602 15.3945 32.0602"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M15.3765 41.7436C16.7364 41.7436 17.8389 40.6598 17.8389 39.3227C17.8389 37.9857 16.7364 36.9019 15.3765 36.9019C14.0165 36.9019 12.9141 37.9857 12.9141 39.3227C12.9141 40.6598 14.0165 41.7436 15.3765 41.7436Z"
        fill={fill}
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
      <path
        d="M20.601 34.1851C21.4092 34.9797 22.0108 35.9222 22.3679 36.9755C25.3566 36.994 26.1649 39.341 26.1649 39.341H19.5859"
        fill={fill}
      />
      <path
        d="M20.601 34.1851C21.4092 34.9797 22.0108 35.9222 22.3679 36.9755C25.3566 36.994 26.1649 39.341 26.1649 39.341H19.5859"
        stroke="#231F20"
        strokeWidth="0.369601"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_22909_12561">
        <rect width="31" height="53.8113" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
